module.exports = __webpack_public_path__ + "img/gallery2.dcb1e844.jpg";